
  import { ExpenseOrder } from '@/entities/finance'
  import { Component } from 'vue-property-decorator'
  import Cell from './cell'

@Component
  export default class StockDetailStatus extends Cell {
  stock = null

  async mounted () {
    const { item } = this

    if (!(item instanceof ExpenseOrder)) {
      this.stock = item?.deal?.stock?.id ? await this.fetchData({
        query: { name: 'fetch', model: 'Stock', params: { id: item?.deal?.stock?.id } },
        force: true,
      }) : null
    } else {
      const details = item?.deal?.id ? (await this.fetchData({
        query: { name: 'find', model: 'StockViewDetails' },
        filter: { id_deal: { _eq: item.deal?.id } },
        force: true,
      }))[0] : null

      this.stock = details?.stock
    }
  }

  get status () {
    const { stock } = this

    return stock?.status
  }
  }
